import { render, staticRenderFns } from "./WaitPayPopupSpecialCoupon.vue?vue&type=template&id=da2af470&scoped=true"
import script from "./WaitPayPopupSpecialCoupon.vue?vue&type=script&lang=js"
export * from "./WaitPayPopupSpecialCoupon.vue?vue&type=script&lang=js"
import style0 from "./WaitPayPopupSpecialCoupon.vue?vue&type=style&index=0&id=da2af470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2af470",
  null
  
)

export default component.exports